import React, { useRef, useState, useEffect, useContext } from "react";
//import { Button } from "@mui/material";
import { useDrag } from "react-dnd";
import { useTutorial } from "../../../context/TutorialContext";
import { WebSocketContext } from "../../../context/WebSocketContext";
import "./tutorial.scss";
import CustomButton from "../../commonComponents/CustomButton";
import CloseButton from "../../commonComponents/CloseButton";
import Modal from "react-modal";
import BlockingOverlay from "../../commonComponents/BlockingOverlay";
//import SsidChartIcon from "@mui/icons-material/SsidChart";

function Tutorial() {
  const {
    currentTutorial,
    localTutorialModalOpen,
    runningTutorial,
    startTutorial,
    closeTutorialModal,
    // NEW: JSON tutorial functions
    getCurrentTutorialContentJSX,
    getCurrentTutorialTitleText,
    getCurrentTutorialHelpText,
    getCurrentTutorialDefinition,
  } = useTutorial();
  const { isFitOngoing, isLoopOngoing } = useContext(WebSocketContext);

  const tutorial1ButtonRef = useRef(null);
  const tutorial2ButtonRef = useRef(null);
  const tutorial3ButtonRef = useRef(null);
  const tutorial4ButtonRef = useRef(null);
  const tutorialRef = useRef(null);

  // State for draggable position
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [displayStep, setDisplayStep] = useState(runningTutorial);
  const [helpModalOpen, setHelpModalOpen] = useState(false);

  // Setup drag functionality using the same pattern as DraggableGraphWindow
  const [, drag] = useDrag(() => ({
    type: "TUTORIAL_MODAL", // Different type from graphs to avoid conflicts
    item: { id: "tutorial-modal" },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
    end: (item, monitor) => {
      const delta = monitor.getDifferenceFromInitialOffset();
      if (delta) {
        setPosition((position) => ({
          x: position.x + delta.x,
          y: position.y + delta.y,
        }));
      }
    },
  }));

  // Force help modal to auto-size after it opens
  useEffect(() => {
    if (helpModalOpen) {
      const timer = setTimeout(() => {
        const modalElement = document.querySelector(
          ".tutorial-modal-portal .ReactModal__Content--after-open"
        );
        if (modalElement) {
          modalElement.style.setProperty("height", "auto", "important");
          modalElement.style.setProperty("min-height", "auto", "important");
        }
      }, 10);

      return () => clearTimeout(timer);
    }
  }, [helpModalOpen]);

  // Sync displayStep with runningTutorial when tutorial progresses
  useEffect(() => {
    setDisplayStep(runningTutorial);
  }, [runningTutorial]);

  // Force position update after modal opens
  useEffect(() => {
    if (localTutorialModalOpen) {
      const timer = setTimeout(() => {
        const modalElement = document.querySelector(
          ".tutorial-modal-portal .ReactModal__Content--after-open"
        );
        if (modalElement) {
          // Calculate position
          const modalWidth = 400;
          const margin = 50;
          const defaultTop = 100;
          let displayRight = true;
          if (
            (currentTutorial === "tutorial1" && runningTutorial >= 8) ||
            (currentTutorial === "tutorial2" && runningTutorial >= 10 &&
              runningTutorial < 19) ||
            runningTutorial >= 22
          ) {
            displayRight = false;
          }
          const defaultLeft = displayRight
            ? window.innerWidth - modalWidth - margin
            : margin;

          const finalLeft = Math.max(
            0,
            Math.min(window.innerWidth - modalWidth, defaultLeft + position.x)
          );
          const finalTop = Math.max(
            0,
            Math.min(window.innerHeight - 200, defaultTop + position.y)
          );

          // Apply positioning with !important to override any external changes
          modalElement.style.setProperty("left", `${finalLeft}px`, "important");
          modalElement.style.setProperty("top", `${finalTop}px`, "important");
          modalElement.style.setProperty("right", "auto", "important");
          modalElement.style.setProperty("bottom", "auto", "important");
        }
      }, 10);

      return () => clearTimeout(timer);
    }
  }, [localTutorialModalOpen, runningTutorial, position]);

  // Calculate modal position based on tutorial step and drag offset
  const getModalStyle = () => {
    const baseStyle = {
      width: "400px",
      height: "auto",
      maxHeight: "80vh", // Prevent modal from being taller than viewport
      minHeight: "150px",
      marginRight: "0",
      transform: "none",
      zIndex: "9999",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: "0", // Remove padding from base as it's handled by content
      borderRadius: "8px",
      backgroundColor: "#f0f8ff",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      border: "none",
      outline: "none",
      position: "fixed", // Ensure fixed positioning
      overflow: "hidden", // Prevent any overflow issues
    };

    // Calculate default position based on tutorial step
    const modalWidth = 400;
    const margin = 50;
    const defaultTop = 100;
    let displayRight = true;
    if (
      (currentTutorial === "tutorial1" && runningTutorial >= 8) ||
      (currentTutorial === "tutorial2" && runningTutorial >= 10)
    ) {
      displayRight = false;
    }
    const defaultLeft = displayRight
      ? window.innerWidth - modalWidth - margin
      : margin;

    // Apply drag offset
    const finalLeft = Math.max(
      0,
      Math.min(window.innerWidth - modalWidth, defaultLeft + position.x)
    );
    const finalTop = Math.max(
      0,
      Math.min(window.innerHeight - 200, defaultTop + position.y)
    );

    return {
      ...baseStyle,
      left: `${finalLeft}px`,
      top: `${finalTop}px`,
      right: "auto", // Override react-modal's inset
      bottom: "auto", // Override react-modal's inset
      // Remove inset entirely - let left/top/right/bottom take precedence
    };
  };

  // No need for local functions anymore - using context functions directly

  return (
    <div className="tutorial" ref={tutorialRef}>
      {!runningTutorial && (
        <div>
      <div className="text">Available introductory tutorials:</div>
      <div className="buttonsContainer">
        <div className="buttonSection">
          <div className="buttonWithText" ref={tutorial3ButtonRef}>
            <CustomButton
              text={"Data Loading"}
              extraClassnames={["tutorialVersion"]}
              handleClick={() => startTutorial("tutorial3")}
              id="tutorial-3"
            />
            <div className="text">
              Using the features of the data loading window.
            </div>
          </div>
          <div className="buttonWithText" ref={tutorial1ButtonRef}>
            <CustomButton
              text={"Raman"}
              extraClassnames={["tutorialVersion"]}
              handleClick={() => startTutorial("tutorial1")}
              id="tutorial-1"
            />
            {/* <Button
              variant="contained"
              size="small"
              sx={{ m: 1 }}
              onClick={() => handleButton1Click()}
              className="button"
              id="load-example-data"
              disabled={isFitOngoing || isLoopOngoing}
            >
              Step 1
            </Button> */}
            <div className="text">
              Analysis of a Raman spectrum using the Autofit.
            </div>
          </div>
          <div className="buttonWithText" ref={tutorial2ButtonRef}>
            <CustomButton
              text={"Reflectivity"}
              extraClassnames={["tutorialVersion"]}
              handleClick={() => startTutorial("tutorial2")}
              id="tutorial-2"
            />
            <div className="text">
              Analysis of a bulk STO sample using the fit.
            </div>
          </div>

          <div className="buttonWithText" ref={tutorial4ButtonRef}>
            <CustomButton
              text={"Thin film analysis"}
              extraClassnames={["tutorialVersion"]}
              handleClick={() => startTutorial("tutorial4")}
              id="tutorial-4"
            />
            <div className="text">
              Analyse the properties of a coating on glass.
            </div>
          </div>


        </div>
      </div>
      </div>)}
      <div className="text">You can always close the tutorial mode by clicking on the <b>Tutorials</b> button in the top bar.</div>

      {/* Welcome Modal */}
      <Modal
        isOpen={localTutorialModalOpen}
        onRequestClose={closeTutorialModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        appElement={tutorialRef.current}
        ariaHideApp={false}
        style={{
          content: getModalStyle(),
          overlay: {
            backgroundColor: "transparent",
            zIndex: "9999",
            pointerEvents: "none",
          },
        }}
        contentLabel="Welcome to Tutorial"
        portalClassName="tutorial-modal-portal"
      >
        <div className="tutorial-modal-content">
          {/* Draggable Header */}
          <div
            ref={drag}
            className="tutorial-modal-drag-handle"
          >
            <div className="tutorial-welcome-modal-title">
              {getCurrentTutorialDefinition()?.name || "Tutorial"}
            </div>
            <div className="tutorial-modal-header-controls">
              <button
                onClick={() => {
                  const tutorialDef = getCurrentTutorialDefinition();
                  if (tutorialDef && displayStep > 1) {
                    setDisplayStep(displayStep - 1);
                  }
                }}
                disabled={!getCurrentTutorialDefinition() || displayStep <= 1}
                className="tutorial-step-button"
              >
                ←
              </button>
              <div className="tutorial-step-indicator">
                Step: {displayStep}
              </div>
              {(() => {
                const tutorialDef = getCurrentTutorialDefinition();
                const isLastStep = tutorialDef && displayStep >= tutorialDef.totalSteps;
                if (isLastStep) {
                  return null;
                }
                return (
                  <button
                    onClick={() => {
                      if (tutorialDef && displayStep < runningTutorial) {
                        setDisplayStep(displayStep + 1);
                      }
                    }}
                    disabled={!tutorialDef || displayStep >= runningTutorial}
                    className="tutorial-step-button"
                  >
                    →
                  </button>
                );
              })()}
            </div>
          </div>

          {/* Scrollable Content */}
          <div className="tutorial-modal-scrollable-content">
            {/* Dynamic Tutorial Content */}
            {currentTutorial && (
              <>
                {/* JSON-based content */}
                {getCurrentTutorialTitleText(displayStep) && (
                  <div className="tutorial-welcome-modal-tutorial-title">
                    {getCurrentTutorialTitleText(displayStep)}
                  </div>
                )}
                {getCurrentTutorialContentJSX(displayStep)}
              </>
            )}
            {!currentTutorial && (
              <div className="tutorial-welcome-modal-tutorial-text">
                Please select a tutorial to begin.
              </div>
            )}
            {currentTutorial &&
              currentTutorial !== "tutorial3" &&
              currentTutorial !== "tutorial4" &&
              currentTutorial !== "tutorial1" && currentTutorial !== "tutorial2" &&(
                <div className="tutorial-welcome-modal-tutorial-text">
                  Tutorial &quot;{currentTutorial}&quot; is not yet implemented.
                </div>
              )}
            
            {/* Help Button - only show if current step has help content */}
            {(getCurrentTutorialHelpText(displayStep) && displayStep === runningTutorial) && (
              <button
                onClick={() => setHelpModalOpen(true)}
                className="tutorial-help-button"
                title="Help"
              >
                ?
              </button>
            )}
          </div>
        </div>
      </Modal>

      {/* Help Modal */}
      <Modal
        isOpen={helpModalOpen}
        onRequestClose={() => setHelpModalOpen(false)}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        appElement={tutorialRef.current}
        ariaHideApp={false}
        style={{
          content: {
            width: "350px",
            height: "auto",
            maxHeight: "70vh",
            minHeight: "auto",
            margin: "auto",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            padding: "0",
            borderRadius: "8px",
            backgroundColor: "#f0f8ff",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            border: "none",
            outline: "none",
            position: "fixed",
            overflow: "hidden",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: "10000",
          },
        }}
        contentLabel="Tutorial Help"
      >
        <div className="tutorial-help-modal-container">
          {/* Help Header */}
          <div className="tutorial-help-modal-header">
            <div className="tutorial-help-modal-title">
              Help
            </div>
            <CloseButton onClose={() => setHelpModalOpen(false)} />
          </div>

          {/* Help Content */}
          <div className="tutorial-help-modal-content">
            <div className="tutorial-welcome-modal-tutorial-text">
              {getCurrentTutorialHelpText(displayStep)}
            </div>
          </div>
        </div>
      </Modal>
      {isFitOngoing || isLoopOngoing ? (
        <BlockingOverlay />
      ) : (
        <></>
      )}
    </div>
  );
}

export default Tutorial;
